import * as App              from './AppLayout'
import * as Login            from './LoginLayout'
import * as NotAuthenticated from './NotAuthenticatedLayout'

export const LoginTemplate = Login
export const AppTemplate = App
export const NotAuthenticatedTemplate = NotAuthenticated

export const NotAuthenticatedWrapper = NotAuthenticated.Main
export const NotAuthenticatedCredentialsWrapper = NotAuthenticated.CredentialsArea

export { default as MainArea } from './MainArea'



// WEBPACK FOOTER //
// ./src/components/templates/index.ts